import { render, staticRenderFns } from "./carte-prix.vue?vue&type=template&id=f29a103e&scoped=true"
import script from "./carte-prix.vue?vue&type=script&lang=js"
export * from "./carte-prix.vue?vue&type=script&lang=js"
import style0 from "./carte-prix.vue?vue&type=style&index=0&id=f29a103e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f29a103e",
  null
  
)

export default component.exports